import { render, staticRenderFns } from "./AddAnnotationDialog.vue?vue&type=template&id=1c011a64&scoped=true"
import script from "./AddAnnotationDialog.vue?vue&type=script&lang=js"
export * from "./AddAnnotationDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAnnotationDialog.vue?vue&type=style&index=0&id=1c011a64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c011a64",
  null
  
)

export default component.exports